import React, { useMemo } from "react";

import { getFlightStreamData } from "shared/components/Flights/FlightStream";
import { FlightStreams } from "shared/gol-api/types/flightSearch";
import { useToggle } from "shared/lib/hooks";

import FlightSegment from "@components/Flights/FlightSegment";
import FlightStreamHeader from "@components/Flights/FlightStreamHeader";

import FlightDetailStream from "./FlightDetailStream";

export default function FlightStream({
  flightStream,
  index,
  changeSelectedStreamParts,
  selectedOptionKey,
  options,
  offerKey,
}: {
  flightStream: FlightStreams;
  index: number;
  changeSelectedStreamParts: (streamIndex: number, value: string) => void;
  selectedOptionKey: string;
  options: any[];
  offerKey: number;
}) {
  const [showDetailStream, toggleShowDetailStream] = useToggle(false);

  const {
    optionsByDate,
    selectedFlightStream,
    selectedDate,
    dateDeparture,
    firstSegment,
  } = useMemo(() => {
    return getFlightStreamData({
      flightStream,
      selectedOptionKey,
      options,
    });
  }, [flightStream, selectedOptionKey, options]);

  return (
    <div className={`flight-stream flight-stream-${index}`}>
      <FlightStreamHeader
        selectedDate={selectedDate}
        dateDeparture={dateDeparture}
        showDetails={showDetailStream}
        toggleShowDetailStream={toggleShowDetailStream}
        firstSegment={firstSegment}
        index={index}
        optionsByDate={optionsByDate}
        changeSelectedStreamParts={changeSelectedStreamParts}
      />
      <FlightSegment
        changeSelectedStreamParts={changeSelectedStreamParts}
        flightStream={flightStream}
        index={index}
        selectedOptionKey={selectedOptionKey}
        toggleShowDetailStream={toggleShowDetailStream}
        options={options}
        offerKey={offerKey}
      />
      <FlightDetailStream
        selectedFlightStream={selectedFlightStream}
        show={showDetailStream}
      />
    </div>
  );
}
